"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnifiedSchemaMessageSeverity = exports.ContainerDocumentClassificationTypesEnum = exports.ContainerDocumentFileTypesEnum = exports.RefinementWorkflowState = exports.RefinementJobState = exports.PaymentStatusEnum = exports.PaymentCurrencyCodeEnum = exports.CommandJobType = exports.CommandJobState = exports.SpecialExtractionProcessingState = exports.ExtractionProviderEnum = exports.ExtractionResultKindEnum = exports.ContainerShareTypeEnum = exports.ContainerRecipientPermissionEnum = exports.RETURNS_TYPES = exports.METADATA_ORIGINAL_TYPES = exports.FOLDER_DESTROY_TYPES = exports.ROOT_FOLDER_TYPES = exports.FOLDER_TYPES = exports.DOCUMENT_TYPES = exports.ContainerTypeEnum = void 0;
var ContainerTypeEnum;
(function (ContainerTypeEnum) {
    ContainerTypeEnum["DELETED_COPY"] = "DeletedCopy";
    ContainerTypeEnum["DELETED_SHARE"] = "DeletedShare";
    ContainerTypeEnum["DOCUMENT_DIGITAL"] = "DocumentDigital";
    ContainerTypeEnum["DOCUMENT_SCAN"] = "DocumentScan";
    ContainerTypeEnum["FOLDER"] = "Folder";
    ContainerTypeEnum["FOLDER_ARCHIVE"] = "FolderArchive";
    ContainerTypeEnum["FOLDER_DESTROYED"] = "FolderDestroyed";
    ContainerTypeEnum["FOLDER_DESTROYING"] = "FolderDestroying";
    ContainerTypeEnum["FOLDER_INBOX"] = "FolderInbox";
    ContainerTypeEnum["FOLDER_SHARED_WITH_ME"] = "FolderSharedWithMe";
    ContainerTypeEnum["FOLDER_TRASH"] = "FolderTrash";
    ContainerTypeEnum["RETURN_BASKET"] = "ReturnBasket";
    ContainerTypeEnum["RETURN_IMMEDIATE"] = "ReturnImmediate";
    ContainerTypeEnum["RETURN_SCHEDULED"] = "ReturnScheduled";
    ContainerTypeEnum["SHRED_BASKET"] = "ShredBasket";
    ContainerTypeEnum["STORAGE_LONG_TERM"] = "StorageLongTerm";
    ContainerTypeEnum["STORAGE_SHORT_TERM"] = "StorageShortTerm";
})(ContainerTypeEnum || (exports.ContainerTypeEnum = ContainerTypeEnum = {}));
exports.DOCUMENT_TYPES = [
    ContainerTypeEnum.DOCUMENT_DIGITAL,
    ContainerTypeEnum.DOCUMENT_SCAN,
];
exports.FOLDER_TYPES = [ContainerTypeEnum.FOLDER];
exports.ROOT_FOLDER_TYPES = [
    ContainerTypeEnum.FOLDER_ARCHIVE,
    ContainerTypeEnum.FOLDER_INBOX,
    ContainerTypeEnum.FOLDER_SHARED_WITH_ME,
    ContainerTypeEnum.FOLDER_TRASH,
];
exports.FOLDER_DESTROY_TYPES = [
    ContainerTypeEnum.FOLDER_DESTROYED,
    ContainerTypeEnum.FOLDER_DESTROYING,
];
exports.METADATA_ORIGINAL_TYPES = [
    ContainerTypeEnum.RETURN_BASKET,
    ContainerTypeEnum.RETURN_IMMEDIATE,
    ContainerTypeEnum.RETURN_SCHEDULED,
    ContainerTypeEnum.SHRED_BASKET,
    ContainerTypeEnum.STORAGE_LONG_TERM,
    ContainerTypeEnum.STORAGE_SHORT_TERM,
];
exports.RETURNS_TYPES = [
    ContainerTypeEnum.RETURN_BASKET,
    ContainerTypeEnum.RETURN_IMMEDIATE,
    ContainerTypeEnum.RETURN_SCHEDULED,
];
var ContainerRecipientPermissionEnum;
(function (ContainerRecipientPermissionEnum) {
    ContainerRecipientPermissionEnum["OWNER"] = "Owner";
    ContainerRecipientPermissionEnum["READ_ONLY"] = "ReadOnly";
    ContainerRecipientPermissionEnum["WRITE"] = "Write";
})(ContainerRecipientPermissionEnum || (exports.ContainerRecipientPermissionEnum = ContainerRecipientPermissionEnum = {}));
var ContainerShareTypeEnum;
(function (ContainerShareTypeEnum) {
    ContainerShareTypeEnum["COPY"] = "Copy";
    ContainerShareTypeEnum["SHARE_WELCOME"] = "ShareWelcome";
})(ContainerShareTypeEnum || (exports.ContainerShareTypeEnum = ContainerShareTypeEnum = {}));
var ExtractionResultKindEnum;
(function (ExtractionResultKindEnum) {
    ExtractionResultKindEnum["CLASSIFICATION"] = "classification";
    ExtractionResultKindEnum["EXTRACTION"] = "extraction";
    ExtractionResultKindEnum["SPLITTING"] = "splitting";
})(ExtractionResultKindEnum || (exports.ExtractionResultKindEnum = ExtractionResultKindEnum = {}));
var ExtractionProviderEnum;
(function (ExtractionProviderEnum) {
    ExtractionProviderEnum["Bedrock"] = "BEDROCK";
    ExtractionProviderEnum["Mustang"] = "MUSTANG";
    ExtractionProviderEnum["Natif"] = "NATIF";
})(ExtractionProviderEnum || (exports.ExtractionProviderEnum = ExtractionProviderEnum = {}));
var SpecialExtractionProcessingState;
(function (SpecialExtractionProcessingState) {
    SpecialExtractionProcessingState["FAILED"] = "Failed";
    SpecialExtractionProcessingState["STARTED"] = "Started";
    SpecialExtractionProcessingState["SUCCEEDED"] = "Succeeded";
})(SpecialExtractionProcessingState || (exports.SpecialExtractionProcessingState = SpecialExtractionProcessingState = {}));
var CommandJobState;
(function (CommandJobState) {
    CommandJobState["CREATED"] = "Created";
    CommandJobState["FAILED"] = "Failed";
    CommandJobState["QUEUED"] = "Queued";
    CommandJobState["STARTED"] = "Started";
    CommandJobState["SUCCEEDED"] = "Succeeded";
})(CommandJobState || (exports.CommandJobState = CommandJobState = {}));
var CommandJobType;
(function (CommandJobType) {
    CommandJobType["CLONE"] = "Clone";
    CommandJobType["DESTROY"] = "Destroy";
    CommandJobType["MOVE"] = "Move";
    CommandJobType["MOVED"] = "Moved";
    CommandJobType["SHARE"] = "Share";
    CommandJobType["UNSHARE"] = "Unshare";
    CommandJobType["UNSHARE_ALL"] = "UnshareAll";
})(CommandJobType || (exports.CommandJobType = CommandJobType = {}));
var PaymentCurrencyCodeEnum;
(function (PaymentCurrencyCodeEnum) {
    PaymentCurrencyCodeEnum["CHF"] = "CHF";
    PaymentCurrencyCodeEnum["EUR"] = "EUR";
})(PaymentCurrencyCodeEnum || (exports.PaymentCurrencyCodeEnum = PaymentCurrencyCodeEnum = {}));
var PaymentStatusEnum;
(function (PaymentStatusEnum) {
    PaymentStatusEnum["COMPLETED"] = "Completed";
    PaymentStatusEnum["ERROR"] = "Error";
    PaymentStatusEnum["MODIFIED"] = "Modified";
    PaymentStatusEnum["OPEN"] = "Open";
})(PaymentStatusEnum || (exports.PaymentStatusEnum = PaymentStatusEnum = {}));
var RefinementJobState;
(function (RefinementJobState) {
    RefinementJobState["Cancelled"] = "Cancelled";
    RefinementJobState["Completed"] = "Completed";
    RefinementJobState["DMSLayerCreated"] = "DMSLayerCreated";
    RefinementJobState["ExtractionErrored"] = "ExtractionErrored";
    RefinementJobState["ExtractionReceived"] = "ExtractionReceived";
    RefinementJobState["OutflowFailed"] = "OutflowFailed";
    RefinementJobState["OutflowInitiated"] = "OutflowInitiated";
    RefinementJobState["OutflowPartiallyFailed"] = "OutflowPartiallyFailed";
    RefinementJobState["Started"] = "Started";
    RefinementJobState["ValidationApproved"] = "ValidationApproved";
    RefinementJobState["ValidationFailed"] = "ValidationFailed";
    RefinementJobState["ValidationSucceeded"] = "ValidationSucceeded";
})(RefinementJobState || (exports.RefinementJobState = RefinementJobState = {}));
var RefinementWorkflowState;
(function (RefinementWorkflowState) {
    RefinementWorkflowState["ACTIVE"] = "Active";
    RefinementWorkflowState["INACTIVE"] = "Inactive";
})(RefinementWorkflowState || (exports.RefinementWorkflowState = RefinementWorkflowState = {}));
var ContainerDocumentFileTypesEnum;
(function (ContainerDocumentFileTypesEnum) {
    ContainerDocumentFileTypesEnum["PDF"] = "PDF";
    ContainerDocumentFileTypesEnum["PDFA_EMBEDDED_ZUGFERD"] = "PDFA_embedded_Zugferd";
})(ContainerDocumentFileTypesEnum || (exports.ContainerDocumentFileTypesEnum = ContainerDocumentFileTypesEnum = {}));
var ContainerDocumentClassificationTypesEnum;
(function (ContainerDocumentClassificationTypesEnum) {
    ContainerDocumentClassificationTypesEnum["BankStatement"] = "BankStatement";
    ContainerDocumentClassificationTypesEnum["DeliveryNote"] = "DeliveryNote";
    ContainerDocumentClassificationTypesEnum["Document"] = "Document";
    ContainerDocumentClassificationTypesEnum["Invoice"] = "Invoice";
    ContainerDocumentClassificationTypesEnum["LegalDocument"] = "LegalDocument";
    ContainerDocumentClassificationTypesEnum["MultiDocument"] = "MultiDocument";
    ContainerDocumentClassificationTypesEnum["OrderConfirmation"] = "OrderConfirmation";
    ContainerDocumentClassificationTypesEnum["PurchaseOrder"] = "PurchaseOrder";
    ContainerDocumentClassificationTypesEnum["SalaryStatement"] = "SalaryStatement";
    ContainerDocumentClassificationTypesEnum["SpeedingFine"] = "SpeedingFine";
})(ContainerDocumentClassificationTypesEnum || (exports.ContainerDocumentClassificationTypesEnum = ContainerDocumentClassificationTypesEnum = {}));
var UnifiedSchemaMessageSeverity;
(function (UnifiedSchemaMessageSeverity) {
    UnifiedSchemaMessageSeverity["ERROR"] = "error";
    UnifiedSchemaMessageSeverity["EXCEPTION"] = "exception";
    UnifiedSchemaMessageSeverity["FATAL"] = "fatal";
    UnifiedSchemaMessageSeverity["WARNING"] = "warning";
})(UnifiedSchemaMessageSeverity || (exports.UnifiedSchemaMessageSeverity = UnifiedSchemaMessageSeverity = {}));
//# sourceMappingURL=document-handling.js.map